import { OfferingOptionModel } from 'interfaces/database';
import ApiService from 'services/ApiService';

class OfferingOptionService extends ApiService<OfferingOptionModel> {
	constructor() {
		super('offeringoption');
	}
}

export default new OfferingOptionService();
